import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function AutomatedPaymentsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.payments.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
